<script setup>
/*
import { ref, nextTick } from 'vue'
import { Gems } from "../gems"

const showVideoList = ref(false)
const showVideoPlayer = ref(false)
const selectedVideo = ref("")
const videoPlayer = ref(null)

async function ToggleVideoContainer() {
  if (showVideoPlayer.value) {
    await CloseVideo();
  }

  showVideoList.value = !showVideoList.value;
}

async function SelectVideo(videoId) {
  const videos = {
    1: "/docs/help-1.mp4",
    2: "/docs/help-2.mp4",
    3: "/docs/help-3.mp4",
    4: "/docs/help-4.mp4",
    5: "/docs/help-5.mp4",
    6: "/docs/help-6.mp4",
    7: "/docs/help-7.mp4",
  };

  selectedVideo.value = ""; // limpa src anterior
  await nextTick();

  selectedVideo.value = videos[videoId] || "";
  showVideoPlayer.value = true;
  showVideoList.value = false;

  await nextTick();

  if (videoPlayer.value) {
    videoPlayer.value.load(); // força carregamento
    videoPlayer.value.currentTime = 0;

    // Espera pelo evento 'canplay'
    const canPlayPromise = new Promise(resolve => {
      const handler = () => {
        videoPlayer.value.removeEventListener("canplay", handler);
        resolve();
      };
      videoPlayer.value.addEventListener("canplay", handler);
    });

    await canPlayPromise;

    try {
      await videoPlayer.value.play();
    } catch (err) {
      console.warn("Erro ao tentar reproduzir o vídeo:", err);
    }
  }
}

async function CloseVideo() {
  if (videoPlayer.value) {
    videoPlayer.value.pause();
    videoPlayer.value.currentTime = 0;

    // Aguarda uma pequena pausa para garantir que o pause foi processado
    await new Promise(resolve => setTimeout(resolve, 100));
  }

  showVideoPlayer.value = false;
  selectedVideo.value = "";
}
*/
function ToggleExtraInfo(event) {
  event.currentTarget.nextElementSibling.classList.toggle('visible')
}
</script>


<template>
  <div>
    <div class="div-help-container">
      <br>
      <div class="div-help-section">
        <div class="div-show-content" @click="ToggleExtraInfo">
          <label>Meu Knolia</label>
          <i class="fas fa-chevron-down"></i>
        </div>
        <div class="div-content">
          <p>O menu "MEU KNOLIA" é a área pessoal do utilizador dentro da aplicação.</p>
          <p>Neste menu, o utilizador pode consultar a sua informação pessoal de competências e atualizar ou classificar as competências associadas ao seu perfil.</p>
          <p>Dentro de "MEU KNOLIA", existem dois submenus principais:</p>
          <ul>
            <li>"CÉDULA DE COMPETÊNCIAS"</li>
            <li>"CLASSIFICAR/ATUALIZAR COMPETÊNCIAS"</li>
          </ul>
        </div>
      </div>

      <div class="div-help-section">
        <div class="div-show-content" @click="ToggleExtraInfo">
          <label>Cédula de competências</label>
          <i class="fas fa-chevron-down"></i>
        </div>
        <div class="div-content">
          <p>O submenu "CÉDULA DE COMPETÊNCIAS" permite consultar a informação de função e atividades, competências, conhecimento, gaps de competências e anexos associada ao utilizador, estas opções estão sempre visíveis em cinco separadores no topo da página, sendo possível navegar ente eles sem sair deste menu.</p>
          <p>Logo abaixo destes separadores, do lado esquerdo, ao lado da fotografia do utilizador, aparece uma breve informação pessoal.</p>
          <p>Esta informação pode incluir:</p>
          <ul>
            <li>Nome do utilizador.</li>
            <li>Número interno.</li>
            <li>Equipa ou equipas a que pertence.</li>
            <li>Indicação sobre se o utilizador aceita ser validador.</li>
          </ul>
          <p>Na última linha desta área, o utilizador pode indicar se aceita ser validador, clicando na opção correspondente.</p>
          <p>Só os utilizadores que aceitam ser validadores poderão receber pedidos de validação. No entanto, para ser validador, não basta aceitar essa opção: o utilizador também precisa de ter a permissão adequada atribuída pelo administrador.</p>
          <p>No lado direito está uma seta, clicando nela é possível voltar para o menu “MEU KNOLIA”.</p>
          <p>No primeiro separador, "FUNÇÃO E ATIVIDADES" é possível ver o cargo bem como uma lista das Atividades, Tarefas e Competências operativas associadas à função do utilizador.</p>
          <p>No canto superior direito existe um botão que permite expandir ou minimizar todas as listas ao mesmo tempo.</p>
          <p>Esta opção é útil quando o utilizador pretende ver toda a informação disponível ou, pelo contrário, fechar as listas para navegar de forma mais simples.</p>
          <p>O utilizador também pode expandir ou fechar cada lista individualmente, clicando diretamente na lista que pretende consultar.</p>
          <!-- <img src="/src/images/01_knolia_help.png" alt="separador de funções e atividades aberto"> -->
          <p>No segundo separador "COMPETÊNCIAS" podem ser consultadas toda as competências do utilizador, bem como o nível de Proficiência, Classificação e estado de Validação de cada uma delas.</p>
          <p>No canto superior direito existe também um botão que permite expandir ou minimizar todas as listas ao mesmo tempo.</p>
          <!-- <img src="/src/images/01_knolia_help.png" alt="separador de Competências aberto"> -->
          <p>O terceiro separador "CONHECIMENTOS", à semelhança dos anteriores, são listadas as competências operativas dos Conhecimentos para as Áreas de competência do utilizador, com a respetiva classificação e estado.</p>
          <p>Em baixo são listadas as competências operativas dos Conhecimentos para as Áreas de competência do utilizador não ativadas, ou sejas, aquelas que, apesar de fazerem parte da função padrão atribuída ao utilizador, foram transitoriamente desativadas no posto de trabalho, embora possam vir a ser reativadas posteriormente.</p>
          <!-- <img src="/src/images/01_knolia_help.png" alt="separador de Conhecimentos aberto"> -->
          <p>No quarto separador "GAPS DE COMPETÊNCIAS", estão listados os gaps de competências para a função padrão do utilizador. À frente de cada um deles é possível ver a percentagem do gap, isto é, uma expressão percentual da proficiência que falta obter para estar alinhada com a proficiência considerada adequada para o nível de envolvimento nas tarefas que foi definido.</p>
          <!-- <img src="/src/images/01_knolia_help.png" alt="separador de Gaps de competência aberto"> -->
          <p>No último separador estão os "ANEXOS", onde é possível anexar, consultar e apagar documentação e ficheiros que possam ser pertinentes, como por exemplo o curriculum vitae e outras certificações.</p>
        </div>
      </div>

      <div class="div-help-section">
        <div class="div-show-content" @click="ToggleExtraInfo">
          <label>Classificar/atualizar competências</label>
          <i class="fas fa-chevron-down"></i>
        </div>
        <div class="div-content">
          <p>O submenu "CLASSIFICAR/ATUALIZAR COMPETÊNCIAS" permite ao utilizador consultar, classificar e atualizar as suas competências e conhecimentos.</p>
          <p>Ao entrar neste ecrã, são listadas as competências operativas que já foram classificadas pelo utilizador.</p>
          <p>No topo existem duas caixas de filtragem e uma caixa de pesquisa.</p>
          <p><strong>Filtros e pesquisa</strong></p>
          <!-- <img src="/src/images/01_knolia_help.png" alt="topo do ecrã, mostrando as duas caixas de filtragem, a caixa de pesquisa, a lupa e a opção Filtrar pela minha função"> -->
          <p>A primeira caixa de filtragem permite filtrar por áreas especificas de competências e conhecimentos.</p>
          <p>A segunda caixa de filtragem permite alterar a listagem apresentada. O utilizador pode escolher:</p>
          <ul>
            <li>Todas.</li>
            <li>Classificadas.</li>
            <li>Não classificadas.</li>
            <li>Validações solicitadas.</li>
            <li>Competências com validação.</li>
          </ul>
          <p>Na caixa de pesquisa, o utilizador pode escrever uma palavra ou expressão especifica e depois clicar no ícone da lupa para procurar.</p>
          <p>No canto superior direito existe a opção Filtrar pela minha função.</p>
          <p>Quando esta opção esta selecionada, apenas são visíveis as competências associadas à função do utilizador.</p>
          <p><strong>Competências destacadas e mensagens novas</strong></p>
          <!-- <img src="/src/images/01_knolia_help.png" alt="topo da lista de competências, mostrando competências destacadas ou com o ícone do olho a piscar"> -->
          <p>No topo da lista podem aparecer competências com o ícone do olho a piscar.</p>
          <p>Este ícone indica que existem novas mensagens associadas a essa competência.</p>
          <p>Também podem aparecer automaticamente no topo:</p>
          <ul>
            <li>Competências com pedido finalizado.</li>
            <li>Competências destacadas manualmente pelo utilizador.</li>
          </ul>
          <p>Esta organização ajuda o utilizador a identificar rapidamente os itens que precisam de atenção.</p>
          <p><strong>Como ler a lista de competências</strong></p>
          <!-- <img src="/src/images/01_knolia_help.png" alt="tabela de competências, com as colunas Descrição, Nível e Validação visíveis"> -->
          <p>A lista de competências e composta por várias colunas.</p>
          <p>Na coluna Descrição, aparece o nome da competência ou conhecimento.</p>
          <p>Na coluna Nível, aparece o nível selecionado pelo próprio utilizador para essa competência.</p>
          <p>Na coluna Validação, aparece o estado da validação.</p>
          <p>Quando o utilizador apenas declarou o nível, o estado aparece como Declarado.</p>
          <p>Quando o utilizador pede validação, o estado passa a indicar que existe um pedido de validação.</p>
          <p>Depois da validação ser aceite, o estado passa a Confirmado, mostrando entre parenteses o nível em que a competência foi validada.</p>
          <p><strong>Solicitar validação</strong></p>
          <!-- <img src="/src/images/01_knolia_help.png" alt="linha de uma competência com a opção Solicitar validação visível"> -->
          <p>Para pedir validação de uma competência, o utilizador deve selecionar primeiro o nível que considera adequado.</p>
          <p>Depois, deve clicar em Solicitar validação.</p>
          <p>O pedido será enviado para validação, para ser avaliado por algum avaliador.</p>
          <p>Depois de submetido, o utilizador deve acompanhar o estado do pedido na coluna Validação.</p>
          <p><strong>Escala de classificação das competências</strong></p>
          <!-- <img src="/src/images/01_knolia_help.png" alt="zona onde o utilizador escolhe o nível da competência, mostrando a escala de 1 a 6"> -->
          <p>A classificação das competências e feita pelo próprio utilizador, usando uma escala de 1 a 6.</p>
          <p>Para competências, a escala significa:</p>
          <ul>
            <li>1 - Uso de forma limitada.</li>
            <li>2 - Uso menos bem.</li>
            <li>3 - Aplico razoavelmente.</li>
            <li>4 - Aplico bem.</li>
            <li>5 - Transformo muito bem.</li>
            <li>6 - Transformo na perfeição.</li>
          </ul>
          <p>O utilizador deve escolher o nível que melhor representa a forma como aplica essa competência no seu trabalho.</p>
          <p><strong>Escala de classificação dos conhecimentos</strong></p>
          <!-- <img src="/src/images/01_knolia_help.png" alt="zona onde o utilizador classifica um conhecimento, mostrando a escala de 1 a 6"> -->
          <p>Quando a classificação se refere a conhecimentos, a escala também vai de 1 a 6, mas o significado é diferente.</p>
          <p>Para conhecimentos, a escala significa:</p>
          <ul>
            <li>1 - Conheço de forma limitada.</li>
            <li>2 - Conheço menos bem.</li>
            <li>3 - Compreendo razoavelmente.</li>
            <li>4 - Compreendo bem.</li>
            <li>5 - Integro muito bem.</li>
            <li>6 - Integro na perfeição.</li>
          </ul>
          <p>O utilizador deve escolher o nível que melhor representa o seu conhecimento sobre o tema.</p>
          <p><strong>Boas praticas</strong></p>
          <!-- <img src="/src/images/01_knolia_help.png" alt="ecrã geral da lista de competências, com filtros e resultados visíveis"> -->
          <p>Para usar este submenu de forma correta, recomenda-se que o utilizador:</p>
          <ul>
            <li>Comece por filtrar pelas competências associadas à sua função.</li>
            <li>Classifique primeiro as competências que conhece melhor.</li>
            <li>Use a pesquisa quando quiser encontrar uma competência específica.</li>
            <li>Leia com atenção a descrição antes de selecionar o nível.</li>
            <li>Solicite validação apenas quando considerar que o nível escolhido está correto.</li>
            <li>Acompanhe o estado dos pedidos de validação depois de os submeter.</li>
          </ul>
        </div>
      </div>

      <div class="div-help-section">
        <div class="div-show-content" @click="ToggleExtraInfo">
          <label>Explorar</label>
          <i class="fas fa-chevron-down"></i>
        </div>
        <div class="div-content">
          <!-- <img src="/src/images/01_knolia_help.png" alt="ecrã inicial do menu Explorar, onde aparecem as opções Atribuir Atividades/Tarefas, Encontrar Pessoas, Meu Potencial e Desafios"> -->
          <p>Ao entrar no menu "EXPLORAR", o utilizador tem acesso às funcionalidades relacionadas com atividades, competências e pesquisa de pessoas.</p>
          <p>Neste ecrã podem estar disponíveis duas opções principais:</p>
          <ul>
            <li>Atribuir atividades/tarefas</li>
            <li>Encontrar Pessoas</li>
            <li>Meu Potencial</li>
            <li>Desafios</li>
          </ul>
          <p>A opção "ATRIBUIR ATIVIDADES/TAREFAS" permite consultar ou gerir atividades associadas às funções dos subordinados do utilizador, permite também acrescentar atividades adicionadas do posto de trabalho aos mesmos.</p>
          <p>A opção "ENCONTRAR PESSOAS" permite pesquisar colaboradores com base em atividades, competências ou critérios específicos.</p>
          <p>No "MEU POTENCIAL" o utilizador pode ver funções e atividades que, de acordo com as suas competências atuais, podem ser executadas, constituindo assim uma oportunidade de diversificação de atividades/funções profissionais.</p>
          <p>A opção "DESAFIOS" estará disponível brevemente e permitirá converter necessidades ou desejos de desenvolvimento de competências, em projetos com objetivos e planos de ação definidos e rastreáveis, auto propostos ou propostos pelas respetivas chefias.</p>
        </div>
      </div>

      <div class="div-help-section">
        <div class="div-show-content" @click="ToggleExtraInfo">
          <label>Atribuir atividades/tarefas</label>
          <i class="fas fa-chevron-down"></i>
        </div>
        <div class="div-content">
          <!-- <img src="/src/images/01_knolia_help.png" alt="ecrã da listagem de subordinados e atividades"> -->
          <p>Esta opção só vai aparecer para utilizadores que tenham subordinados, e aqui será apresentada uma lista dos subordinados, ao selecionar um subordinado, aparecem na parte de baixo duas listas de atividades, uma com as atividades atribuídas ao subordinado selecionado, tanto as da função como as adicionadas ao posto de trabalho e outra com as atividades adicionadas ao posto de trabalho que podem ser atribuídas, para atribuir estas atividades basta clicar e arrastar para a lista de atividades adicionadas do posto de trabalho que se encontra do lado esquerdo.</p>
          <p>À frente de cada atividade apresentada nestas listas, é indicado o grau de proficiência que o utilizador pretende que o subordinado possua para a respetiva atividade.</p>
          <p>No canto superior direito existe uma área de pesquisa, para que seja mais rápido e fácil encontrar subordinados pelo nome.</p>
        </div>
      </div>

      <div class="div-help-section">
        <div class="div-show-content" @click="ToggleExtraInfo">
          <label>Encontrar Pessoas</label>
          <i class="fas fa-chevron-down"></i>
        </div>
        <div class="div-content">
          <!-- <img src="/src/images/01_knolia_help.png" alt="ecrã Encontrar Pessoas, com a lista de atividades do lado esquerdo, os critérios selecionados do lado direito e a tabela de resultados em baixo"> -->
          <p>Ao selecionar "ENCONTRAR PESSOAS", o utilizador pode procurar colaboradores que tenham determinadas atividades ou competências.</p>
          <p>No topo do ecrã existem áreas de filtragem e pesquisa. A primeira caixa permite escolher o tipo de critério que se pretende utilizar, permitindo procurar por pessoas, competências, atividades ou funções específicas.</p>
          <p>Do lado esquerdo aparece uma listagem de pessoas, competências, atividades ou funções disponíveis (dependendo da opção selecionada anteriormente). O utilizador pode arrastar para a zona dos critérios um ou mais elementos desta listagem que pretenda usar como critério de pesquisa.</p>
          <p>Do lado direito aparece a área Critérios, onde ficam visíveis os critérios selecionados. Nesta zona também podem aparecer competências associadas aos critérios escolhidos.</p>
          <p>No canto superior direito da área de critérios existe a opção Limpar, que permite retirar todos os critérios selecionados e iniciar uma nova pesquisa.</p>
          <p>O botão com o ícone da lupa permite executar a pesquisa.</p>
          <p>Na parte inferior do ecrã surge a tabela de resultados da pesquisa. Esta tabela pode apresentar os seguintes campos:</p>
          <p>Nome, onde aparece o colaborador encontrado.</p>
          <p>Proficiência, onde e apresentada a media de proficiência associada aos critérios.</p>
          <p>Ajustamento médio ao requisito, que indica o nível de correspondência entre o colaborador e os critérios escolhidos.</p>
          <p>Cobertura, que indica a cobertura dos critérios selecionados.</p>
          <p>Cédula, onde poderá existir acesso à informação detalhada do colaborador, caso o utilizador tenha permissão.</p>
          <p>Se não existirem resultados, a tabela ficará vazia. Nesse caso, o utilizador pode remover alguns critérios, limpar a pesquisa ou escolher uma atividade diferente.</p>
        </div>
      </div>

      <div class="div-help-section">
        <div class="div-show-content" @click="ToggleExtraInfo">
          <label>Listas Guardadas</label>
          <i class="fas fa-chevron-down"></i>
        </div>
        <div class="div-content">
          <!-- <img src="/src/images/01_knolia_help.png" alt="separador Listas Guardadas, que mostra uma lista guardada ou, caso não existam listas, o ecrã vazio correspondente"> -->
          <p>Na área "ENCONTRAR PESSOAS", também existe o separador "LISTAS GUARDADAS".</p>
          <p>Este separador permite consultar listas de pesquisa que tenham sido guardadas anteriormente.</p>
          <p>As listas guardadas servem para facilitar pesquisas repetidas, evitando que o utilizador tenha de voltar a selecionar constantemente os mesmos critérios.</p>
          <p>Ao entrar em Listas Guardadas, o utilizador deve selecionar a lista pretendida. Depois de aberta, a lista apresenta os colaboradores ou critérios guardados anteriormente.</p>
          <p>Se não existirem listas guardadas, esta área pode aparecer sem resultados.</p>
        </div>
      </div>
      <!--
      <div class="div-help-section">
        <div class="div-show-content" @click="ToggleExtraInfo">
          <label>Meu Potencial</label>
          <i class="fas fa-chevron-down"></i>
        </div>
        <div class="div-content">
          <img src="/src/images/01_knolia_help.png" alt="ecrã de menu meu potencial">
          <p>(Explicação mais detalhada deste menu?)</p>
        </div>
      </div>
      -->

      <div class="div-help-section">
        <div class="div-show-content" @click="ToggleExtraInfo">
          <label>Utilizadores</label>
          <i class="fas fa-chevron-down"></i>
        </div>
        <div class="div-content">
          <!-- <img src="/src/images/01_knolia_help.png" alt="ecrã Utilizadores, que mostra a caixa de pesquisa, a lista de colaboradores e as colunas de permissões"> -->
          <p>O menu "UTILIZADORES" permite consultar a lista de colaboradores.</p>
          <p>Neste ecrã aparece uma tabela com vários utilizadores e a informação associada a cada um.</p>
          <p>No topo existe uma caixa de pesquisa, onde é possível escrever o nome ou parte do nome do colaborador que se pretende encontrar.</p>
          <p>A tabela pode apresentar informação como:</p>
          <ul>
            <li>Nome</li>
            <li>Função</li>
            <li>Categoria</li>
            <li>Consultar Cédulas</li>
            <li>Hierarquia</li>
          </ul>
          <p>Para cada utilizador listado nos resultados da pesquisa existem dois ícones: Consultar Cédulas e Hierarquia. Caso o utilizador tenha as permissões necessárias, os ícones estarão ativos. O ícone Consultar Cédulas permite visualizar a cédula de competências do utilizador, enquanto o ícone Hierarquia permite visualizar os seus subordinados diretos.</p>
        </div>
      </div>

      <div class="div-help-section">
        <div class="div-show-content" @click="ToggleExtraInfo">
          <label>Pedidos</label>
          <i class="fas fa-chevron-down"></i>
        </div>
        <div class="div-content">
          <!-- <img src="/src/images/01_knolia_help.png" alt="ecrã Pedidos, que mostra os separadores, filtros, lista de pedidos e estado de validação"> -->
          <p>O menu "PEDIDOS" permite consultar pedidos relacionados com competências, validações ou certificações.</p>
          <p>Quando existe uma notificação vermelha junto ao menu "PEDIDOS", isso indica que há pedidos pendentes ou notificações que precisam de atenção.</p>
          <p>Ao entrar no menu, no topo do ecrã existe uma caixa de filtragem, onde o utilizador pode escrever o texto que pretende procurar.</p>
          <p>Também existem filtros por estado:</p>
          <ul>
            <li>Em aberto</li>
            <li>Publicados</li>
            <li>Todos</li>
          </ul>
          <p>O utilizador pode ainda ordenar os pedidos por data, usando a opção de ordenação apresentada no topo da listagem.</p>
          <p>Na tabela de pedidos, os pedido têm os seguintes campos:</p>
          <p>Data pedido, onde se vê a data em que o pedido foi criado.</p>
          <p>Descrição, onde aparece a competência, conhecimento ou atividade relacionada com o pedido.</p>
          <p>Classificação, onde aparece a escala ou nível atribuído.</p>
          <p>Validador, onde aparece a pessoa responsável pela validação.</p>
          <p>Validação, onde se vê o estado do pedido.</p>
          <p>Data validação, quando o pedido já tiver sido validado.</p>
          <p>Quando o pedido ainda está em tratamento, o estado pode aparecer como em analise.</p>
          <p>Quando existe o ícone do olho no final da linha, o utilizador pode clicar para consultar mais detalhe sobre esse pedido.</p>
          <!-- <img src="/src/images/01_knolia_help.png" alt="da janela que abre quando se carrega no olhinho"> -->
          <p>Quando não existem pedidos para os filtros selecionados, aparece a mensagem Sem resultados.</p>
          <p>Neste caso, o utilizador deve verificar se esta no separador correto e se o filtro escolhido e o adequado.</p>
          <p>Por exemplo, se estiver selecionado Em aberto, podem não aparecer pedidos porque não existem pedidos pendentes nesse momento.</p>
          <p>Para ver todos os pedidos, deve selecionar a opção Todos.</p>
        </div>
      </div>

      <div class="div-help-section">
        <div class="div-show-content" @click="ToggleExtraInfo">
          <label>Privacidade</label>
          <i class="fas fa-chevron-down"></i>
        </div>
        <div class="div-content">
          <!-- <img src="/src/images/01_knolia_help.png" alt="ecrã Privacidade, que mostre os separadores Utilizadores e Aplicação, bem como as permissões disponíveis"> -->
          <p>O utilizador pode aqui consultar e aceitar os termos de privacidade, selecionando a opção “Tomei conhecimento e entendi a informação prestada (obrigatório para prosseguir a experiência no KNOLIA)”.</p>
          <p>Pode ainda autorizar a utilização da sua foto na aplicação, selecionando a opção abaixo (não é obrigatória para a utilização do sistema).</p>
          <p>Por fim basta carregar no botão em baixo “Prosseguir experiência no KNOLIA”.</p>
        </div>
      </div>

      <div class="div-help-section">
        <div class="div-show-content" @click="ToggleExtraInfo">
          <label>Sair</label>
          <i class="fas fa-chevron-down"></i>
        </div>
        <div class="div-content">
          <!-- <img src="/src/images/01_knolia_help.png" alt="menu lateral com a opção Sair visível"> -->
          <p>O menu "SAIR" permite terminar a sessão no Knolia.</p>
          <p>O utilizador deve usar esta opção sempre que terminar o trabalho na aplicação, especialmente se estiver a usar um computador partilhado.</p>
          <p>Para sair:</p>
          <ol>
            <li>Ir ao menu lateral esquerdo.</li>
            <li>Clicar em "SAIR".</li>
            <li>Aguardar que a aplicação termine a sessão.</li>
          </ol>
        </div>
      </div>

    </div>
  </div>
</template>

<style scoped>
a { 
  color: #6f1afc;
  cursor: pointer;
}

.div-video-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 20px;
}

.div-video-container p {
  cursor: pointer;
  margin: 0;
}

[control-video-container] {
  cursor: pointer;
}

.fa-film {
  transform: scale(1.3);
  cursor: pointer;
}

.div-help {
  display: grid;
  grid-template-columns: 40% 55%;
  place-content: space-between;
}

.div-last-help {
  grid-template-columns: 23% 73%;
}

.div-help p:first-child {
  margin: 0;
}

img {
  width: 100%;
}

.div-video-list-container {
  position: absolute;
  display: flex;
  justify-content: space-around;
  font-size: 0.8em !important;
  padding: 17px 15px !important;
  z-index: 99 !important;
  width: 350px !important;
  right: 55px;
  top: 60px;
  background-color: var(--knolia-rating-scale);
  color: var(--knolia-yellow-white);
  border-radius: 10px;
  box-shadow: 0 3px 4px rgb(0 0 0 / 10%), 0 4px 10px rgb(0 0 0 / 20%);
}

.div-video-list-container span {
  width: fit-content;
  cursor: pointer;
  line-height: 15px;
}

.fa-times-circle,
.fa-times {
  cursor: pointer;
  transform: scale(1.1);
}

.fa-times-circle:hover,
.fa-times:hover {
  color: var(--knolia-blue-3);
}

.div-btn-close {
  display: flex;
  justify-content: center;
  width: fit-content;
  height: fit-content;
  transform: scale(1.4);
  margin: -5px -12px 0 0;
}

.div-btn-close i {
  color: white;
  align-self: baseline;
  font-size: 10px;
}

.div-video-list {
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.div-video-list span:hover {
  color: var(--knolia-blue-3);
}

#video {
  position: relative;
  width: 70%;
}

#div-video-player-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.div-modal {
  position: fixed;
  /* Stay in place */
  z-index: 100;
  /* Sit on top */
  left: 0;
  top: 0;
  width: 100%;
  /* Full width */
  height: 100%;
  /* Full height */
  background-color: rgb(0, 0, 0);
  /* Fallback color */
  background-color: rgba(0, 0, 0, 0.5);
  /* Black w/ opacity */
}

.div-close-video {
  position: absolute;
  right: 12.4%;
  top: 6.5%;
}

.div-close-video i {
  color: var(--knolia-gray);
}

.tdMain a {
  cursor: pointer;
  color: var(--default-app-color);
}

.fa-chevron-down,
.fa-chevron-up {
  cursor: pointer;
}

.div-help-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
}

.div-show-content {
  display: flex;
  background-color: var(--bs-secondary-text-emphasis);
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  border-radius: 30px;
  padding: 4px 15px 4px 12px;
  width: 100%;
}

.div-show-content label {
  cursor: pointer;
  user-select: none;
}

.div-content {
  padding: 20px 10px 0 10px;
  display: none;
}

.div-content img {
  margin-block-start: 1em;
  margin-block-end: 1em;
}

.div-content p a {
  color: var(--knolia-blue-3)!important;
}

.visible {
  display: block;
}

.video-play-icon {
  margin-left: 3px;
  color: var(--knolia-blue-3);
  font-size: 1em;
  transition: color 0.2s ease, transform 0.2s ease;
  vertical-align: middle;
}

a:hover .video-play-icon {
  color: var(--knolia-blue-1);
  transform: scale(1.25);
}


@media screen and (max-width: 1370px) {
  .div-close-video {
    top: 10.2%;
    right: 11.5%;
  }
}

@media screen and (min-width: 2500px) {
  .div-close-video {
    right: 27.8%;
    top: 19.2%;
  }

  .div-close-video i {
    font-size: 3em;
  }

  #video {
    width: 40%;
  }
}
</style>
